export default function ProductSection() {
    const productData = [
      { name: "Blum HK Top", src: "/BLUM_HK_TOP.jpg" },
      { name: "Cubical", src: "/cubical.png" },
      { name: "Blin", src: "/GIRO01APERTO-low.jpg" },
      { name: "Club Handle", src: "/cta.jpg" },
      { name: "Euro Cylinder", src: "/INVISIBLE SLIDING.jpg" },
      { name: "Concealed Hinge", src: "/Platinum_900_DEF.jpg" },
      { name: "Mortise Lock", src: "/SYNCRO PROFILE SLIDING DOORS.jpg" },
      { name: "Tower Bolt", src: "/TELESCOPIC SLIDING DOOR 1+2.jpg" },
      { name: "Flush Pull", src: "/walking wardrobe.jpg" },
      { name: "Cabinet Knob", src: "/WOODEN KITCHEN ACCESSORY.jpg" },
      { name: "Drawer Channel", src: "/MURPHY BED FITTING.jpg" },
    //   { name: "Door Closer", src: "/LAPIS.png" },
    //   { name: "Sliding Roller", src: "/BRAMANTE.jpg" },
    //   { name: "Magnetic Catcher", src: "/1.jpg" },
    //   { name: "L-Bracket", src: "/2.jpg" },
    //   { name: "Glass Clamp", src: "/3.jpg" },
    //   { name: "Shelf Support", src: "/4.jpg" },
    //   { name: "Furniture Screw Kit", src: "/4.jpg" },
    ];
  
    return (
      <section className="bg-gray-900 py-16 px-4 md:px-20 text-white">
        <h2 className="text-3xl font-bold mb-10 text-center">Our Featured Products</h2>
  
        {/* Masonry-style grid with overlay */}
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 space-y-4">
          {productData.map((product, index) => (
            <div
              key={index}
              className="relative w-full overflow-hidden rounded-xl shadow-lg break-inside-avoid group"
            >
              <img
                src={product.src}
                alt={product.name}
                className="w-full h-auto object-cover group-hover:scale-[1.03] transition-transform duration-300"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-black/60 text-white text-sm md:text-base px-3 py-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                {product.name}
              </div>
            </div>
          ))}
        </div>
      </section>
    );
  }
  